import { Flex } from '@chakra-ui/react';
import { tableToolbarStyle } from 'shared/styles';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';

interface ISalesDataToolbarProps {
    tableInstance: {
        state: {
            globalFilter: string;
        };
        setGlobalFilter: (filterValue: string) => void;
    };
}

const SalesDataToolbar = ({ tableInstance }: ISalesDataToolbarProps) => {
    const { state, setGlobalFilter } = tableInstance;

    return (
        <Flex {...tableToolbarStyle}>
            <GlobalFilter globalFilter={state.globalFilter} setGlobalFilter={setGlobalFilter} />
        </Flex>
    );
};

export default SalesDataToolbar;
